'use client';

import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, SearchBodyContainer } from 'components/Container/Container.css';
import { TabsNavigationSearch } from 'components/TabsNavigation';
import SearchEvent from 'templates/Search/SearchEvent';
import SearchPlaces from 'templates/Search/SearchPlaces';
import SearchProducers from 'templates/Search/SearchProducers';

import { SearchEventResult } from 'searchEvent.d';
import { ParamsResult } from 'ParamsResult.d';
import { SearchProducersResult } from 'searchProducers.d';
import { SearchPlacesResult } from 'searchPlaces.d';
import { tabsSearch } from 'constants/search';
import { TabItem } from 'components/TabsNavigation/TabsNavigation';

export type SearchEventTemplateProps = {
  params: ParamsResult;
  searchEventsResult: SearchEventResult;
  otherSearchDataResult?: SearchEventResult;
  searchPlaceResult: SearchPlacesResult;
  searchOrganizerResult: SearchProducersResult;
  termURL: string;
  isMobile: boolean;
  dateURL?: string | string[];
  tabURL?: string | string[];
};

function SearchWithTermTemplate({
  params,
  searchEventsResult,
  otherSearchDataResult,
  searchPlaceResult,
  searchOrganizerResult,
  dateURL,
  tabURL,
  termURL,
  isMobile,
}: SearchEventTemplateProps) {
  const [selectedTab, setSelectedTab] = useState(tabURL || tabsSearch.event.tabName);

  const buildTemplate = () => {
    switch (selectedTab) {
      case tabsSearch.place.tabName:
        return <SearchPlaces searchDataResult={searchPlaceResult} params={params} isMobile={isMobile} />;
      case tabsSearch.organizer.tabName:
        return <SearchProducers searchDataResult={searchOrganizerResult} params={params} isMobile={isMobile} />;
      default:
        return (
          <SearchEvent
            searchDataResult={searchEventsResult}
            otherSearchDataResult={otherSearchDataResult}
            params={params}
            dateURL={dateURL}
            termURL={termURL}
            isMobile={isMobile}
          />
        );
    }
  };

  const handleSelectTab = (item: TabItem) => {
    setSelectedTab(item?.tabName);
  };

  return (
    <div>
      <TabsNavigationSearch hasFilter={selectedTab === tabsSearch.event.tabName} handleChange={handleSelectTab} />

      <div className={SearchBodyContainer}>
        <div className={Container}>{buildTemplate()}</div>
      </div>
    </div>
  );
}

export default observer(SearchWithTermTemplate);
